import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_139: FaireProductEntity = {
  token: "legacy_prod_abbott-139",
  type: "product",
  name: "Butterfly Garden Canister-5.5 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/56ef2ec9b3feb5c4e0624b57be79fa46a8e3f94cdcdad045425cdb9bb7cd1cfe.jpeg",
  priceDollars: 22,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
